import {createContext} from 'react';

import type {CrispClient} from '../services';

export interface CrispContextValue {
  crisp: CrispClient;
}

// Dans son propre fichier, comme `MixpanelCtx` : React Fast Refresh ne rafraîchit à chaud qu'un
// module n'exportant QUE des composants. Exporté pour que Storybook fournisse un bouchon sans
// monter le vrai `CrispProvider`, qui chargerait le SDK Crisp du site de production.
export const CrispContext = createContext<CrispContextValue | undefined>(undefined);
